import { RootState } from '../types';
import { ActionTree } from 'vuex';
import { Client, UploadFileAsJsonRequest } from '@/common/apis/DeviceApi';
import ApiProvider from '@/common/apis/ApiProvider';
import { ViewsState } from './types';
import Vue from 'vue';
import _ from 'lodash';

interface ISavePromise {
    promise: Promise<any>;
    resolve: () => void;
    reject: (e: any) => void;
}

const loadPromises: {[deviceNumber: string]: Promise<any>} = {};

export const actions: ActionTree<ViewsState, RootState> = {
    load({ commit, rootState }, args: {deviceNumber: string}): Promise<any> {
        return loadPromises[args.deviceNumber]
        || (loadPromises[args.deviceNumber] = new Promise<any>(async (resolve, reject) => {

            try {
                const api = ApiProvider.getDeviceApi();
                const devices = await api.getFileAsJson('/views.json', args.deviceNumber);
                const views = devices.content as {[key: string]: any};
                if (views) {
                    commit('loaded', { deviceNumber: args.deviceNumber, views });
                    resolve(views);
                }
                return null;
            } catch (e) {
                reject(e);
            }
            delete loadPromises[args.deviceNumber];
        }));

    },
    async store({ state, commit, rootState }, args: {deviceNumber: string, key: string, payload: any}) {
        commit('updateView', args);
    },
    async upload({state, rootState}, args: {deviceNumber: string}) {
        const api = ApiProvider.getDeviceApi();
        const response = await api.uploadFileAsJson(new UploadFileAsJsonRequest({
            deviceId: args.deviceNumber,
            filename: '/views.json',
            content: state.views[args.deviceNumber],
        }));
    },
    // Uploads some fake cotent
    async uploadFakeContent({ commit, rootState }, args: {deviceNumber: string, key: string, payload: any}) {
        /* tslint:disable */
        const content = {"relays":[{"friendlyName":"Motor-lant. ","icon":"fa fa-lightbulb-o","no":0},{"friendlyName":"Nav lant. ","icon":"","no":1},{"friendlyName":"Kortlampe","icon":"fa fa-image","no":2},{"friendlyName":"Spots kahyt","icon":"fa fa-bullseye","no":3},{"friendlyName":"Varme","icon":"fa fa-thermometer-4","no":4},{"friendlyName":"Anker lant. ","icon":"fa fa-anchor","no":5},{"friendlyName":"Dæks lys","icon":"","no":6},{"friendlyName":"VHF / AIS","icon":"fa fa-podcast","no":7},{"friendlyName":"Pilot","icon":"fa fa-gear","no":8},{"friendlyName":"GPS plotter","icon":"fa fa-television","no":9},{"friendlyName":"Køleskab","icon":"fa fa-snowflake-o","no":10},{"friendlyName":"Tryk vand","icon":"fa fa-s15","no":11},{"friendlyName":"Radio musik","icon":"fa fa-music","no":12},{"friendlyName":"Lænse pumpe","icon":"fa fa-gear","no":13}],"buttons-v2":{"name":"","items":[{"hidden":false,"relayNumber":0},{"hidden":false,"relayNumber":1},{"hidden":false,"relayNumber":2},{"hidden":false,"relayNumber":3},{"hidden":false,"relayNumber":4},{"hidden":false,"relayNumber":5},{"hidden":false,"relayNumber":6},{"hidden":false,"relayNumber":7},{"hidden":false,"relayNumber":8},{"hidden":false,"relayNumber":9},{"hidden":false,"relayNumber":10},{"hidden":false,"relayNumber":11},{"hidden":false,"relayNumber":12},{"hidden":false,"relayNumber":13}]},"floorplan":{"buttons":[{"type":"relay","icon":"fa fa-times-circle-o","relayNumber":"5","x":0.5267379679144385,"y":0.045112781954887216,"size":"medium","colorOn":"Green","colorOff":"Red"},{"type":"relay","icon":"fa fa-toggle-right","relayNumber":"0","x":0.5855614973262032,"y":0.4492481203007519,"size":"medium","colorOn":"Green","colorOff":"Red"},{"type":"relay","icon":"fa fa-caret-square-o-down","relayNumber":"6","x":0.5909090909090909,"y":0.4906015037593985,"size":"medium","colorOn":"Green","colorOff":"Red"},{"type":"relay","icon":"fa fa-caret-square-o-right","relayNumber":"1","x":0.8903743315508021,"y":0.7894736842105263,"size":"medium","colorOn":"Green","colorOff":"Red"},{"type":"relay","icon":"fa fa-caret-square-o-left","relayNumber":"1","x":0.15775401069518716,"y":0.7706766917293233,"size":"medium","colorOn":"Green","colorOff":"Red"},{"type":"relay","icon":"fa fa-thermometer-4","relayNumber":"4","x":0.22459893048128343,"y":0.8308270676691729,"size":"medium","colorOn":"Green","colorOff":"Red"},{"type":"relay","icon":"fa fa-snowflake-o","relayNumber":"10","x":0.4304812834224599,"y":0.825187969924812,"size":"small","colorOn":"Green","colorOff":"Red"}]}};
        /* tslint:enable */

        const api = ApiProvider.getDeviceApi();
        const response = await api.uploadFileAsJson(new UploadFileAsJsonRequest({
            deviceId: args.deviceNumber,
            filename: '/views.json',
            content,
        }));
        commit('loaded', { deviceNumber: args.deviceNumber, content });
    },
};
